import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { Uris } from '../Uris';
import { GlobalFunction } from '../globalFunction';
import { userLogin, LoginResponse, passwordConfirm } from '../../interfaces/auth/auth.interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction,
  ) {}

  headersBasicAuth(value: userLogin): { headers: HttpHeaders } {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'es',
      Authorization: 'Basic ' + btoa(`${value.username}:${value.password}`),
    });
    return { headers: headers };
  }

  login(user: userLogin): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${Uris.API_LOGIN}`, {}, this.headersBasicAuth(user)).pipe(
      map((resp: LoginResponse) => {
        console.debug('AuthService.login - response', resp);
        if (resp.user.type === 1) {
          this.globalFunction.animation('error', 'Usuario no autorizado');
        }
        if (resp.user.type !== 1) {
          this.router.navigate(['/admin/dashboard']);
          if (resp && resp['token']) {
            localStorage.setItem('token', resp['token']);
          }
          if (resp && resp.user) {
            localStorage.setItem('USER', JSON.stringify(resp.user));
          }
        }
        return resp;
      }),
    );
  }

  recover(email: string): Observable<unknown> {
    return this.http.post(`${Uris.PASSWORD_SENDREQUEST}`, { email }).pipe(map((resp) => resp));
  }

  passwordConfirm(password: passwordConfirm): Observable<unknown> {
    return this.http.post(`${Uris.PASSWORD_CONFIRM}`, password).pipe(map((resp) => resp));
  }

  logout(): Observable<unknown> {
    return this.http
      .post(`${Uris.API_LOGOUT}`, {}, this.globalFunction.headers())
      .pipe(map((resp) => resp));
  }
}
